//  All Cash Equivalent sub-asset fund rules

import { IProduct } from '../../../../models/product'
import { ClassificationRulesService } from '../../../classification-rules/classification-rules.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class CashEquivalentTaxableRule implements IFundRule {
  ruleName = FundRuleName.CASH_EQUIVALENTS_TAXABLE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isTaxableCashEquivalent(fund)
  }
}

export class CashEquivalentMuniRule implements IFundRule {
  ruleName = FundRuleName.CASH_EQUIVALENTS_MUNI
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isMuniCashEquivalent(fund)
  }
}

export class CashEquivalentStableValueRule implements IFundRule {
  ruleName = FundRuleName.CASH_EQUIVALENTS_STABLE_VALUE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isStableFundCashEquivalent(fund)
  }
}
